import { render, staticRenderFns } from "./CreatePassword.vue?vue&type=template&id=5aa00d44&"
import script from "./CreatePassword.vue?vue&type=script&lang=js&"
export * from "./CreatePassword.vue?vue&type=script&lang=js&"
import style0 from "./CreatePassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports